window.addEventListener('load', function () {
  PetiteVue.createApp({
    App,
    $delimiters: ['${', '}'],
  }).mount()
})

function App() {
  return {
    isModalOpen: false,
    selectedUserType: null,
    isFormSubmitted: false,
    closeModal() {
      window.location = '#'
    },
    openModal() {
      window.location = '#register'
    },
    selectUserType(type) {
      window.location = '#register?type=' + type
    },
    handleMounted() {
      // client side hash routing - allow user to navigate through modal flow with native browser history
      if (window.location.hash) {
        // if hash present on page load, make it empty to reset modal flow
        this.closeModal()
      }
      window.addEventListener('hashchange', () => {
        const hash = window.location.hash
        this.latestHash = hash
        const SELECTED_USER_PREFIX = '#register?type='
        if (hash.startsWith(SELECTED_USER_PREFIX)) {
          this.isModalOpen = true
          this.selectedUserType = hash.substring(SELECTED_USER_PREFIX.length)
        } else if (hash.startsWith('#register')) {
          this.isModalOpen = true
          this.selectedUserType = null
        } else {
          this.isModalOpen = false
          this.selectedUserType = null
        }
      }, false)
    }
  }
}
